import {i18nInstance} from "../localization/core";

export enum PriceType {
  specifications,
  milestonesAdvice,
  mobileApp,
  desktopApp,
  backend,
  frontend,
  web
}

interface PriceListContract {
  title: string
  priceType: PriceType
}

export default class PricePlan {
  title: string
  priceCost: number
  private supportedPriceTypes: PriceType[]
  isFixedCost?: boolean
  priceUnitTime?: 'm' | 'h'

  /**
   *
   * @param options
   * [options.priceCost] in XAF.
   * [options.isFixedCost] determine if it is a fixed cost or a variable cost that starts from that amount.
   */
  constructor(options: {
    title: string,
    priceCost: number,
    isFixedCost?: boolean,
    supportedPriceTypes: PriceType[] | 'all',
    priceUnitTime?: 'm' | 'h'
  }) {
    this.priceCost = options.priceCost
    this.title = options.title

    if (options.supportedPriceTypes === 'all') {
      this.supportedPriceTypes = this.pricesList.map(p => p.priceType)
    } else {
      this.supportedPriceTypes = options.supportedPriceTypes
    }

    this.isFixedCost = options.isFixedCost ?? true
    this.priceUnitTime = options.priceUnitTime
  }

  get pricesList(): PriceListContract[] {
    const trans = (key: string) => i18nInstance.t(`commons.owner.pricePlanItem${key.substring(0, 1).toUpperCase() + key.substring(1)}`)
    return [
      {title: trans('specifications'), priceType: PriceType.specifications},
      {title: trans('milestones'), priceType: PriceType.milestonesAdvice},
      {title: trans('mobile'), priceType: PriceType.mobileApp},
      {title: trans('backend'), priceType: PriceType.backend},
      {title: trans('frontend'), priceType: PriceType.frontend},
      {title: trans('web'), priceType: PriceType.web},
      {title: trans('desktop'), priceType: PriceType.desktopApp},
    ]
  }

  get supportedPricesList(): PriceListContract[] {
    return this.pricesList.filter(priceList => this.supportedPriceTypes.includes(priceList.priceType)).sort()
  }

  isSupportedPriceList(priceType: PriceType): boolean {
    return this.supportedPriceTypes.includes(priceType)
  }

  get priceCostUSD(): number {
    const usdXafRate = 560
    return Math.floor(this.priceCost / usdXafRate)
  }
}
